/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Badge_UnlockInputs */

const en_landing_pricing_feature_badge_unlock = /** @type {(inputs: Landing_Pricing_Feature_Badge_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dofollow unlocked with our badge`)
};

const zh_landing_pricing_feature_badge_unlock = /** @type {(inputs: Landing_Pricing_Feature_Badge_UnlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放置徽章即可解锁 Dofollow`)
};

/**
* | output |
* | --- |
* | "Dofollow unlocked with our badge" |
*
* @param {Landing_Pricing_Feature_Badge_UnlockInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_badge_unlock = /** @type {((inputs?: Landing_Pricing_Feature_Badge_UnlockInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Badge_UnlockInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_badge_unlock(inputs)
	return zh_landing_pricing_feature_badge_unlock(inputs)
});
export { landing_pricing_feature_badge_unlock as "landing.pricing.feature_badge_unlock" }